import { Link, useLocation } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { DEFAULT_LOGO_URL } from '../../constants';

// LinkedIn icon (simple SVG)
const LinkedInIcon = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="20" 
    height="20" 
    viewBox="0 0 24 24" 
    fill="currentColor"
    className="shrink-0"
  >
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const isSettingsPage = location.pathname === '/settings';

  return (
    <footer className="relative bg-gray-50 border-t border-gray-200 h-[72px] px-6 flex items-center mt-auto">
      {/* Reserve space so footer content does not sit under the settings control */}
      <div className="max-w-7xl mx-auto w-full pr-[4.5rem] sm:pr-[4.75rem]">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          {/* Logo and brand */}
          <div className="flex items-center gap-3">
            <img
              src={DEFAULT_LOGO_URL}
              alt="Svenry"
              className="h-8 w-auto object-contain"
            />
            <span className="text-lg font-semibold text-gray-800">Svenry</span>
          </div>

          {/* Contact and links */}
          <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-8 text-sm text-gray-600">
            <a 
              href="mailto:info@svenry.com" 
              className="hover:text-primary-600 transition-colors"
            >
              info@svenry.com
            </a>
            <a 
              href="https://www.svenry.com/privacy-policy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-primary-600 transition-colors"
            >
              Privacy Policy
            </a>
            <a 
              href="https://www.linkedin.com/company/svenry/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-primary-600 transition-colors flex items-center gap-1"
              title="Svenry on LinkedIn"
            >
              <LinkedInIcon />
              <span className="hidden sm:inline">LinkedIn</span>
            </a>
          </div>

          {/* Copyright */}
          <div className="text-sm text-gray-500">
            © {currentYear} Svenry AB
          </div>
        </div>
      </div>
      <Link
        to="/settings"
        className={`absolute right-6 top-1/2 z-10 flex size-12 shrink-0 -translate-y-1/2 items-center justify-center rounded-full shadow-lg transition-all duration-200 hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50 ${
          isSettingsPage
            ? 'bg-primary-600 text-white'
            : 'border border-gray-200 bg-white text-gray-600 hover:bg-primary-50 hover:text-primary-600'
        }`}
        title="Settings"
        aria-label="Open settings"
      >
        <Settings className="size-5 shrink-0 block" strokeWidth={2} aria-hidden />
      </Link>
    </footer>
  );
}
